import { useAppConfig } from '@/root/shared-hooks/appConfig/useAppConfig'

/** The tenant's default company country and phone code (`+372` form), from the tenant config. */
export const useDefaultCountry = () => {
  const { defaultCountry, defaultCountryCallingCode } = useAppConfig()

  return {
    defaultCountryCode: defaultCountry,
    defaultIntlCode: `+${defaultCountryCallingCode}`,
  }
}
